import type { ProductNearToLimit } from 'apiConnector/discover/lifeCycle';

import 'components/discover/post-trade/life-cycle/index.css';
import { Section } from 'components/discover/post-trade/life-cycle/section/section-content';

import type { LifeCycleItemProps } from './section-container';
import { LifeCycleSectionContainer, lifeCycleApi } from './section-container';

export function NearToCapitalBarrierSection(props: LifeCycleItemProps) {
  return (
    <LifeCycleSectionContainer
      title="nearToCapitalBarrier"
      fetchData={lifeCycleApi.fetchNearToCapitalBarrier}
      {...props}
    >
      {(product: ProductNearToLimit) => (
        <Section.Content
          distanceToLimit={product.distanceToCapitalLimit}
          underlyings={product.underlyingList.map(u => ({
            bloombergCode: u.bloombergCode,
            distanceToLimit: u.distanceToCapitalLimit,
            limitHit: u.capitalLimitHit,
          }))}
        />
      )}
    </LifeCycleSectionContainer>
  );
}
